<template>

<div class="profile">
	
	<com-open v-if="profile === false" />

	<template v-if="profile !== false">

		<template v-for="(section, index) in sections">

			<com-section :section="section" :first="index === 0" v-on:back="onBack" :key="section.id" v-if="section.id === currentSection" />

		</template>

	</template>

	<com-recommendation v-if="finished" />

</div>

</template>

<script>

import comOpen from './profile/Open'
import comSection from './common/Section'
import comRecommendation from './profile/Recommendation'
import thresholds from '@/assets/thresholds.json'

export default {

	components: {

		'com-open': comOpen,
		'com-section': comSection,
		'com-recommendation': comRecommendation

	},

	created: function() {

		this.$store.commit('session/reset')

		if (this.$route.name === 'Create') {

			this.$store.commit('session/profile', true)

		}

	},

	computed: {

		profile: function() {

			return this.$store.getters['session/values/named']

		}

	},

	watch: {

		profile: {

			deep: true,

			handler: function(n) {

				var systemValues = {
					'1a': null,
					'1b': null,
					'2': false,
					'3': false,
					'4': false,
					'5': false,
					'6': false,
					'7': false,
					'8': false
				}

				if(n['ref.lumbar'] && n['ref.femoral']) {

					systemValues['4'] = (n['ref.lumbar'] - n['ref.femoral']) >= 1

				} 

				if(n['ref.mof'] && n['ref.hip']) {

					var mofModifier = 1
					var hipModifier = 1

					if(n['ref.falls']) {

						mofModifier = 1.3
						hipModifier = 1.3

					}

					if(n['ref.lumbar'] && n['ref.femoral']) {

						var difference = n['ref.lumbar'] - n['ref.femoral']

						if (difference >= 1 && difference < 2) {

							if (mofModifier < 1.1) mofModifier = 1.1

						} else if (difference >= 2 && difference < 3) {

							if (mofModifier < 1.2) mofModifier = 1.2

						} else if (difference >= 3 && difference < 4) {

							if (mofModifier < 1.3) mofModifier = 1.3

						} else if (difference >= 4 && difference < 5) {

							if (mofModifier < 1.4) mofModifier = 1.4

						} 

					} 
					
					if(n['ref.dose']) {

						if (mofModifier < 1.15) mofModifier = 1.15
						if (hipModifier < 1.2) hipModifier = 1.2

					}

					systemValues['1a'] = n['ref.mof'] * mofModifier
					systemValues['1b'] = n['ref.hip'] * hipModifier

				}

				if(n['ref.age']) {

					var threshold = this.$_.findWhere(thresholds, {
						age: parseInt(n['ref.age'])
					})

					if(threshold) {

						if(systemValues['1a'] < threshold.lat_mof && systemValues['1b'] < threshold.lat_hip) {

							systemValues['2'] = true

						}

						if(systemValues['1a'] >= threshold.tt_mof || systemValues['1b'] >= threshold.tt_hip || systemValues['1a'] >= threshold.uat_mof || systemValues['1b'] >= threshold.uat_hip) {

							systemValues['3'] = true

						}

						if(n['ref.mof'] >= threshold.tt_mof || n['ref.hip'] >= threshold.tt_hip) {

							systemValues['5'] = true

						}

						if(n['ref.mof'] >= threshold.uat_mof || n['ref.hip'] >= threshold.uat_hip) {

							systemValues['6'] = true

						}

						if(n['ref.mof'] >= threshold.vhf_mof || n['ref.hip'] >= threshold.vhf_hip) {

							systemValues['7'] = true

						}

					}

				}

				if(parseFloat(n['ref.lowest']) > parseFloat(n['ref.lumbar']) || parseFloat(n['ref.lowest']) > parseFloat(n['ref.femoral'])) {

					systemValues['8'] = true

				}

				this.$_.each(systemValues, function(value, key) {

					this.$store.commit('session/values/named', {
						name: 'system.' + key,
						value: value
					})

				}.bind(this))

			}

		}

	},
	
	methods: {

		onBack: function() {

			this.$store.dispatch('back', this.$store.getters['session/section/completed'][this.$store.getters['session/section/completed'].length - 1])

		}

	}

}

</script>

<style scoped>

.profile {
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	overflow: hidden;
	transition: all 300ms ease-in-out;
}


</style>
